/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'

interface Props {
  data: any
  color: string
  lightColor: string
}

const StakingWeekChart: React.FC<Props> = ({ data, color, lightColor }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(data, color, lightColor))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode])

  return (
    <>
      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_staking_week_chart'
        style={{ height: '300px' }}
        className='card-rounded-bottom'></div>
      {/* end::Chart */}
    </>
  )
}

function getChartOptions (data: any, color: string, lightColor: string): ApexOptions {
  return {
    series: [
      {
        name: 'Days',
        // data: [44, 55, 41, 67, 22, 43, 21],
        data: (data?.daily ?? []).map((item: any) => item.total),
      },
    ],
    chart: {
      type: 'area',
      height: 300,
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: [color],
    },
    colors: [lightColor],
    xaxis: {
      categories: (data?.daily ?? []).map((item: any) => item.day),
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    // tooltip: {
    //   custom: function ({ w, dataPointIndex, seriesIndex }) {
    //     const datas = w.globals.initialSeries
    //     const dataColor = w.globals.colors

    //     const extractedData = extractSingleBarChart(datas, dataColor, dataPointIndex, seriesIndex)

    //     return `<div class="bg-kumopack-base-black py-2 px-5 text-kumopack-base-white">
    // 						    <div>${formatNumberCommas(extractedData.total)} users</div>
    // 					</div>`
    //   },
    // },
  }
}

export default StakingWeekChart
